import useColumnBooking from '../logic/useColumnBooking'
import HeaderPatient from './headerPatient'
import { notification } from 'antd'
import { FooterTable } from 'components/atoms'
import { ActionType } from 'components/atoms/actions'
import { SEARCH_QUERY_PATIENT_DEFAULT, SEARCH_QUERY_URL } from 'constants/query'
import { useOnlineStatus } from 'detectConnectServer'
import { useModalConfirm, useQuerySearch } from 'hooks'
import { t } from 'i18next'
import { IPatient } from 'pages/patientReceive/interfaces'
import useModalReceive from 'pages/patientReceive/logic/useModalReceive'
import { forwardRef, useEffect, useImperativeHandle } from 'react'
import { useSelector } from 'react-redux'
import { useReceiveServices } from 'services'
import { ESocketEventName, socketIoService } from 'socket'
import { querySearchSelector } from 'store/searchQuerySlice'
import { StyledTable } from 'styles/styledGlobal'

interface IRefProps {
  reload: () => void
}

const PatientContainer = (props: any, ref: any) => {
  const {
    items,
    setItems,
    handleOnSearch,
    totalRecord,
    setTotalRecord,
    getTotalRecord,
    loading,
    payloadSearch,
    offset,
    reload,
    getItems,
    getPayloadSearch
  } = useQuerySearch<IPatient>(
    SEARCH_QUERY_URL.Patient,
    SEARCH_QUERY_PATIENT_DEFAULT
  )
  const { columnsPatient } = useColumnBooking(offset, totalRecord, handleAction)

  useImperativeHandle(ref, () => ({ reload }))
  const isOnline = useOnlineStatus()
  const { hidePatient } = useReceiveServices()
  const { openConfirmDelete } = useModalConfirm()

  const { handleAddNewBooking, handleEditProfile } = useModalReceive({
    ignoreNavigate: true
  })

  function updateData(originalData: IPatient, updateData: any): IPatient {
    for (const key in updateData) {
      if (key in originalData) {
        ;(originalData as any)[key] = updateData[key]
      }
    }
    return originalData
  }

  function checkCurFilter(curFilter: any, data: IPatient): boolean {
    if (curFilter?.query) {
      if (curFilter.query['name']) {
        const nameFilter = curFilter.query['name'].toLowerCase()
        if (
          !data.full_name ||
          !data.full_name.toLowerCase().includes(nameFilter)
        ) {
          return false
        }
      }
      if (curFilter.query['from'] && curFilter.query['to'] && data.created_at) {
        const from = curFilter.query['from']
        const to = curFilter.query['to']
        const createdAt = new Date(data.created_at).getTime()
        if (isNaN(createdAt) || createdAt < from || createdAt > to) {
          return false
        }
      }
    }
    return true
  }

  useEffect(() => {
    const handleCreatePatient = (data: any) => {
      const curFilter = getPayloadSearch()
      const items = getItems()
      const existingIndex = items?.findIndex(
        (item: IPatient) => item.user_id === data.user_id
      )

      if (existingIndex > -1) {
        if (checkCurFilter(curFilter, data)) {
          setItems((prevItems) => {
            const updatedItems = [...prevItems]
            updatedItems[existingIndex] = updateData(
              updatedItems[existingIndex],
              data
            )
            return updatedItems
          })
        } else if (curFilter.offset === 0) {
          reload(true)
        }
      } else if (checkCurFilter(curFilter, data) && curFilter.offset === 0) {
        reload(true)
      }
    }

    const handleDeletePatient = (data: any) => {
      const curFilter = getPayloadSearch()
      const items = getItems()
      const existingIndex = items?.findIndex(
        (item: IPatient) => item.user_id === data
      )

      if (existingIndex > -1 && curFilter.offset === 0) {
        reload(true)
      }
    }

    const handleCreatePatientFromMobile = (data: any) => {
      const curFilter = getPayloadSearch()
      if (curFilter.offset === 0 && checkCurFilter(curFilter, data)) {
        // reload(true)
        setItems((prevItems) => {
          const updatedTotalRecord = getTotalRecord() + 1
          setTotalRecord(updatedTotalRecord)
          const remainingItems = prevItems.slice(0, -1)
          const updatedItems = [data, ...remainingItems]
          return updatedItems
        })
      }
    }

    socketIoService.subscribeCreatePatient(handleCreatePatient)
    socketIoService.subscribeDeletePatient(handleDeletePatient)
    socketIoService.subscribeCreatePatientFromMobile(
      handleCreatePatientFromMobile
    )

    return () => {
      socketIoService.unsubscribeEvent(ESocketEventName.MANAGE_PATIENT_TOPIC)
      socketIoService.unsubscribeEvent(
        ESocketEventName.MANAGE_PATIENT_DELETE_TOPIC
      )
      socketIoService.unsubscribeEvent(
        ESocketEventName.MANAGE_PATIENT_ADD_TOPIC
      )
    }
  }, [setItems])
  const query = useSelector(querySearchSelector)[SEARCH_QUERY_URL.Patient.name]
  useEffect(() => {
    console.log('[PatientContainer] isOnline: ', isOnline)
    handleOnSearch({
      ...SEARCH_QUERY_PATIENT_DEFAULT,
      limit: query?.limit || 50
    })
  }, [isOnline])
  function handleAction(action: ActionType, row: IPatient) {
    switch (action) {
      case ActionType.Add:
        handleAddNewBooking(row)
        break
      case ActionType.Reload:
        reload()
        break
      case ActionType.Edit:
        handleEditProfile(row, () => reload())
        break
      case ActionType.Delete:
        openConfirmDelete(`${t('delete-patient')} "${row?.full_name}"`, () =>
          hidePatient(row.user_id).then((res) => {
            if (res._successfully) {
              notification.success({ message: t('delete-patient-success') })
              reload()
            }
          })
        )
        break
      default:
        break
    }
  }

  return (
    <>
      <HeaderPatient
        isPatientPage
        onSearch={(query) =>
          handleOnSearch({
            ...getPayloadSearch(),
            query,
            offset: 0
          })
        }
        querySearch={payloadSearch?.query}
      />
      {/* <PanelBooking
        onChange={(item: any) => handleOnSearchQuery({})}
        totalRecord={totalRecord}
        // tabsButton={C_PATIENT_FILTERS}
        tabDefault={filterDefault}
      /> */}
      <StyledTable
        sticky
        columns={columnsPatient}
        dataSource={items}
        pagination={false}
        rowKey="user_id"
        loading={loading}
        $maxHeight="calc(100vh - 400px)"
        footer={() => (
          <FooterTable
            forPage={SEARCH_QUERY_URL.Patient.name}
            totalRecord={totalRecord}
            showOptionAll
          />
        )}
      />
    </>
  )
}

export default forwardRef<IRefProps, any>(PatientContainer)
